import { useUsers } from '../../../../lib/api/swrApi';
import { PickerForm } from '../PickerForm/PickerForm';
import { COMMON_LABELS, TEAM_MANAGMENT_LABELS } from '../../../../lib/constants/labelKeys';
import { PickerFormItem } from '../PickerForm/PickerFormTypes';
import { CommonModalProps } from '../../../../lib/types/aemDataModels';
import { useAssignUserToTeam } from '../../../../lib/api/postApi';
import { filterUsers, renderUser, userIdFn } from '../../compound/CourseAssignment/CourseAssignment.utils';
import styles from './TeamAccordionItem.module.scss';
import { ERROR_MESSAGES_SPLITTER } from '../../../../lib/constants/globals';
import { isPromiseFullfiled, isPromiseRejected } from '../../../../lib/utils/promises';
import useErrorMapping from '../../../../lib/hooks/useErrorMapping';

type TeamAccordionItemModalProps = { teamId: string } & CommonModalProps;

const TeamAccordionItemModal = ({
  teamId,
  isModalOpened,
  dialogTitle,
  noItemsSelectedMessage,
  onSuccess,
  onCancel,
}: TeamAccordionItemModalProps) => {
  const { data, mutate, isLoading, error } = useUsers({ teamId });
  const joinTeam = useAssignUserToTeam(teamId);
  const { getParsedErrorMessage } = useErrorMapping();

  const handleSubmit = async (items: PickerFormItem[]) => {
    const result = await Promise.allSettled<void>([
      ...items.map(async ({ id: userId }) => {
        await joinTeam(userId);
      }),
    ]);

    if (result.some(isPromiseFullfiled)) {
      mutate();
    }

    const rejected = result.filter(isPromiseRejected);

    if (rejected.length) {
      onSuccess(false);
      throw new Error(rejected.map(item => getParsedErrorMessage(item.reason)).join(ERROR_MESSAGES_SPLITTER));
    }

    onSuccess();
  };

  return (
    <PickerForm
      loading={isLoading}
      error={error}
      isOpen={isModalOpened}
      onSubmit={handleSubmit}
      labels={{
        selectedItemsHeadingKey: COMMON_LABELS.DIALOG.SELECTED_ITEMS,
        noItemsSelectedMessage,
        dialogTitle,
        submitButtonLabelKey: TEAM_MANAGMENT_LABELS.addMemberDialog.ASSIGN_BUTTON,
        assignedSummaryKey: TEAM_MANAGMENT_LABELS.addMemberDialog.ASSIGNED_SUMMARY,
      }}
      onCancel={onCancel}
      value={[
        {
          titleKey: TEAM_MANAGMENT_LABELS.addMemberDialog.USERS_TAB,
          list: data?.map(user => ({ ...user, id: user.userId })) ?? [],
          render: renderUser,
          filterFunction: filterUsers,
          idFunction: userIdFn,
          searchPlaceholderKey: COMMON_LABELS.SEARCH.USER,
        },
      ]}
      customClasses={{ dialogActionButtons: styles.dialogActionButtons }}
    />
  );
};

export default TeamAccordionItemModal;
